export { default } from './QualificationDetails';
